import React, { useState } from "react";
import "./AddPartnerForm.css";

/**
 * API base URL configuration - SAME AS PartnerSearch.js
 */
const getApiBase = () => {
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }
  
  if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
    return "http://localhost:5000";
  }
  
  return "";
};

const API_BASE = getApiBase();

const EditPartnerForm = ({ partner, onClose, onSave }) => {
  // ✅ Handle multiple possible field name conventions from backend
  const partnerId = partner.id || partner.asset2_id || partner.partner_id;
  const partnerName = partner.name || partner.asset2_name || partner.partner_name || "";
  const partnerCode = partner.number || partner.asset2_code || partner.partner_code || "";

  const [formData, setFormData] = useState({
    name: partnerName,    
    number: partnerCode, 
  });

  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.name) {
      setError("Partner name is required.");
      return;
    }

    if (!partnerId) {
      setError("Partner ID is missing. Cannot update.");
      return;
    }

    setLoading(true);
    setError(null);

    try {
      const url = `${API_BASE}/api/partners/${partnerId}`;
      console.log('🎨 Updating partner:', url, formData);

      const response = await fetch(url, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        credentials: 'include', // ✅ Added for consistency
        body: JSON.stringify(formData),
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.error || `HTTP ${response.status}: Failed to update partner`);
      }

      console.log('✅ Partner updated:', data);
      alert("✅ Partner updated successfully!");
      
      setTimeout(() => {
        onSave();
        onClose();
      }, 300);
    } catch (error) {
      console.error("❌ Error updating partner:", error);
      setError(error.message || "An error occurred.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <button className="close-button" onClick={onClose} disabled={loading}>✖</button>

        <h3>Partner</h3>

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="edit-partner-name">Partner Name:</label>
            <input 
              id="edit-partner-name"
              type="text" 
              name="name"
              value={formData.name} 
              onChange={handleChange} 
              required 
              disabled={loading}
            />
          </div>
          
          <div className="form-group">
            <label htmlFor="edit-partner-code">Partner Code:</label>
            <input 
              id="edit-partner-code"
              type="text" 
              name="number"
              value={formData.number} 
              onChange={handleChange} 
              disabled={loading}
            />
            {formData.number && formData.number.startsWith('#') && (
              <div 
                style={{
                  width: '50px',
                  height: '30px',
                  backgroundColor: formData.number,
                  border: '1px solid #ccc',
                  borderRadius: '4px',
                  marginTop: '8px'
                }}
                title="Partner preview"
              />
            )}
          </div>
          
          {error && (
            <p className="error-message" style={{ 
              color: '#c33', 
              padding: '10px', 
              backgroundColor: '#fee',
              borderRadius: '4px' 
            }}>
              ⚠️ {error}
            </p>
          )}

          <button 
            type="submit" 
            className="submit-btn"
            disabled={loading}
          >
            {loading ? 'Updating...' : 'Update Partner'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default EditPartnerForm;